import { isUuid } from '../../../js/app/react/validators';
import { useClientId } from '../../_hooks/useClientId';
import { useProposedPlansQuery } from '../api/useProposedPlansQuery';
import { useLocalStorageKey } from './useLocalStorageKey';

// default to first plan if nothing is stored in local storage
export const useSelectedPlan = () => {
  const clientId = useClientId();

  const { data } = useProposedPlansQuery();

  const localStorageKey = useLocalStorageKey();

  if (!data) {
    return null;
  }

  const { PrintArea, ConsumerArea } = window.ADV.store.getState();

  if (PrintArea && isUuid(PrintArea.fpId)) {
    return data.find(({ planId }) => planId === PrintArea.fpId) ?? data[0];
  }

  if (clientId) {
    const fpId = localStorage.getItem(localStorageKey);

    if (isUuid(fpId)) {
      return data.find(({ planId }) => planId === fpId) ?? data[0];
    }
  }

  if (ConsumerArea && isUuid(ConsumerArea.fpId)) {
    return data.find(({ planId }) => planId === ConsumerArea.fpId) ?? data[0];
  }

  return data[0];
};
